import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

// Google Calendar's official 24-color palette, copied verbatim (values verified against
// the Google Calendar people picker). Ordered so neighbouring indexes never share a hue
// family. Cycles when there are more users than colors. Index 0 (current user) is blue.
const USER_CALENDAR_COLORS = [
  '#4285f4', // cobalt
  '#d50000', // tomato
  '#0b8043', // basil
  '#f6bf26', // banana
  '#8e24aa', // grape
  '#f4511e', // tangerine
  '#009688', // eucalyptus
  '#d81b60', // cherry blossom
  '#7cb342', // pistachio
  '#3f51b5', // blueberry
  '#ef6c00', // pumpkin
  '#33b679', // sage
  '#ad1457', // radicchio
  '#7986cb', // lavender
  '#f09300', // mango
  '#795548', // cocoa
  '#e67c73', // flamingo
  '#039be5', // peacock
  '#c0ca33', // avocado
  '#9e69af', // amethyst
  '#e4c441', // citron
  '#616161', // graphite
  '#b39ddb', // wisteria
  '#a79b8e', // birch
];

export function getUserColor(userIndex: number | Nullish): string {
  const index = isNil(userIndex) || Number.isNaN(userIndex) || userIndex < 0 ? 0 : userIndex;

  return USER_CALENDAR_COLORS[index % USER_CALENDAR_COLORS.length];
}
